export class Actu {
    id: number = 0;
    title: string = '';
    description: string = '';
    summary: string = '';
    pubStart: string = '';
    picture: string = '';
}